export default {
  i18n: {
    breadcrumb: '国际化产品',
    tips: '通过切换语言按钮，来改变当前内容的语言。',
    btn: '切换英文',
    title1: '常用用法',
    p1: '要是你把你的秘密告诉了风，那就别怪风把它带给树。',
    p2: '没有什么比信念更能支撑我们度过艰难的时光了。',
    p3: '只要能把自己的事做好，并让自己快乐，你就领先于大多数人了。',
    title2: '组件插值',
    info: 'Element组件需要国际化，请参考 {action}。',
    value: '文档'
  }
  ,
  layout: {
    header: {
      logo: 'KJ3231煤炭产量管理系统'
    }
    ,
    notFound: {
      desc: '啊哦~ 你所访问的页面不存在',
      backHome: '返回首页',
      backPrev: '返回上一页'
    }
  }
  ,
  header: {
    tooltips: {
      fullscreenEnter: '全屏',
      fullscreenCancel: '取消全屏',
      bellDefault: '消息中心',
      bellWithCount: '有{count}条未读消息'
    }
  },
  pages: {
    login: {
      title: 'KJ3231煤炭产量管理系统',
      submit: '登录',
      usernamePlaceholder: '请输入用户名',
      passwordPlaceholder: '请输入密码',
      rules: {
        usernameRequired: '请输入用户名',
        passwordRequired: '请输入密码'
      },
      success: '登录成功'
    },
    about: {
      breadcrumb: '关于',
      title: 'KJ3231煤炭产量管理系统',
      backendVersion: '后台版本',
      webVersion: 'web版本',
      fetchError: '网络异常！获取列表失败！'
    },
    running: {
      cumulativeT: '累计(t)',
      flowTh: '流量(t/h)',
      beltSpeedMs: '带速(m/s)',
      empty: '查无数据',
      videoNotSupported: '该设备未添加监控或配置错误'
    },
    tabs: {
      breadcrumb: '消息中心',
      unreadLabel: '未读消息({count})',
      markRead: '标为已读',
      markAllRead: '全部标为已读',
      readLabel: '已读消息({count})',
      delete: '删除',
      deleteAll: '删除全部',
      noneWarning: '暂无数据!!!',
      fetchError: '网络异常！获取消息中心列表失败！',
      listError: '网络异常！获取列表失败！'
    },
    deviceList: {
      breadcrumb: '设备列表',
      loading: '玩命加载中...',
      index: '序号',
      region: '地区',
      mineName: '煤矿名称',
      scaleName: '秤名称',
      viewInfo: '查看信息',
      viewStatus: '查看状态信息',
      addSuccess: '添加成功',
      addFail: '添加失败',
      updateSuccess: '修改成功',
      updateFail: '修改失败',
      fetchError: '网络异常！获取列表失败！',
      addError: '网络异常！添加失败',
      updateError: '网络异常！修改失败',
      accountRequired: '请输入账号',
      nameRequired: '请输入姓名',
      pwdSet: '请设置密码',
      pwdMin: '密码长度至少5位',
      pwdConfirmRequired: '请输入确认密码',
      pwdMismatch: '两次密码不一致',
      roleTypeRequired: '请选择角色类型',
      phoneRequired: '请输入电话',
      lengthRange: '长度在 3 到 15 个字符'
    },
    globalSet: {
      breadcrumb: '功能模块设置',
      homeColors: {
        title: '首页颜色设置',
        menuBg: '菜单背景',
        homeBg: '首页背景',
        titleColor: '标题',
        textColor: '文字',
        button1: '按钮1',
        button2: '按钮2'
      },
      actions: {
        save: '保存',
        restoreDefault: '恢复默认',
        confirm: '确 定',
        uploadQuery: '上传记录查询'
      },
      switch: {
        open: '打开',
        close: '关闭',
        yes: '是',
        no: '否'
      },
      db14: { mainSwitch: '生成DB14文件总开关:' },
      zfw: { label: '生成ZFW文件:' },
      dtjk: { label: '生成DTJKMY0002S文件:' },
      snjson: {
        label: '生成SNJson文件:',
        secondsSuffix: ':秒生成一次'
      },
      report: {
        label: '生成洗选产品数质量日报表:',
        everyDay: '每天',
        oClock: '点生成'
      },
      display: {
        cnb: '显示产能比:',
        device: '显示设备状态:'
      },
      motor: { label: '电机监测:' },
      messageCenter: { label: '是否开启消息中心:' },
      companyName: { label: '是否显示公司名称:' },
      virtual: {
        totalSwitch: '是否开启总累积量虚拟秤:',
        scaleNameLabel: '秤名称:',
        scaleNamePlaceholder: '秤名称'
      },
      multithreading: { label: '是否开启多线程:' },
      coalPlatform: {
        title: '煤炭信息监管服务平台设置',
        mineName: '煤矿名称:',
        mineNamePh: '煤矿名称',
        mineCode: '煤矿编码:',
        mineCodePh: '煤矿编码',
        uploadScale: '上传皮带秤',
        selectPlaceholder: '请选择',
        serverIP: '服务器IP:',
        serverIPPh: '服务器IP',
        port: '端口:',
        portPh: '服务器端口',
        account: '账号:',
        accountPh: '账号',
        password: '密码:',
        passwordPh: '密码',
        dataUpload: '煤炭信息监管数据上传:',
        receivePound: '是否接收运销数据:'
      },
      cloud: {
        title: '云平台上传设置',
        serverIP: '云服务器IP:',
        serverIPPh: '云服务器IP',
        port: '端口:',
        portPh: '云服务器端口',
        clientId: '客户端Id:',
        clientIdPh: '云客户端Id',
        account: '账号:',
        accountPh: '云账号',
        password: '密码:',
        passwordPh: '云密码',
        uploadSwitch: '是否开启数据上传:'
      }
    },
    alarmControl: {
      breadcrumb: '报警消音控制',
      title: '报警消音控制',
      statusActive: '报警进行中',
      statusMuted: '已消音 / 正常',
      turnOn: '开启报警',
      turnOff: '关闭 (消音)'
    },
    basicInfo: {
      startTime: '开始运行时间',
      lastStopTime: '上次停止时间',
      todayRunDuration: '当日运行时长',
      cumulativeT: '累计(t)',
      flowTh: '流量(t/h)',
      beltSpeedMs: '带速(m/s)',
      dayProduction: '日产量(t)',
      monthProduction: '月产量(t)',
      yearProduction: '年产量(t)',
      viewMore: '查看更多信息',
      empty: '查无数据',
      videoNotSupported: '该设备未添加监控或配置错误',
      connectSuccess: '连接成功',
      connectFail: '连接失败'
    }
    ,
    dynamic: {
      cumulativeT: '累计(t)',
      flowTh: '流量(t/h)',
      beltSpeedMs: '带速(m/s)',
      empty: '查无数据',
      videoNotSupported: '该设备未添加监控或配置错误'
    }
    ,
    moreDeviceInfo: {
      back: '返回',
      clockSync: '时钟同步',
      clientTime: '本机时间',
      serverTime: '服务器时间',
      timeDiffSec: '时间差(秒)',
      syncedTime: '校准后时间',
      offsetSec: '手动偏移(秒)',
      useServerTime: '使用服务器时间',
      clockSyncSaved: '时钟校准已保存',
      serverTimeUnavailable: '无法获取服务器时间',
      cumulativeT: '累计(t)',
      flowTh: '流量(t/h)',
      beltSpeedMs: '带速(m/s)',
      startTime: '开始运行时间',
      lastStopTime: '上次停止时间',
      todayRunDuration: '当日运行时长',
      dayProduction: '日产量(t)',
      monthProduction: '月产量(t)',
      yearProduction: '年产量(t)',
      hourCNB: '时产能比(%)',
      monthCNB: '月产能比(%)',
      dayCNB: '日产能比(%)',
      yearCNB: '年产能比(%)',
      empty: '查无数据',
      hourBar: '时产量柱形图',
      dayBar: '日产量柱形图',
      monthBar: '月产量柱形图',
      yearBar: '年产量柱形图',
      realtimeFlow: '实时流量曲线',
      axisHour: '时间(时)',
      axisDay: '时间(日)',
      axisMonth: '时间(月)',
      axisYear: '时间(年)',
      axisTime: '时间',
      axisProdT: '产量(t)',
      axisFlow: '流量',
      diagramConnOk: '连接正常',
      diagramConnBad: '连接异常',
      diagramCameraOk: '摄像头正常',
      diagramCameraBad: '摄像头异常',
      videoNotSupported: '该设备未添加监控或配置错误'
    }
    ,
    coalTaxCalc: {
      breadcrumb: '折算与税费测算',
      title: '折算与税费测算',
      loadDemo: '加载示例',
      calculate: '测算',
      fillDemo: '填充示例',
      calcDone: '测算完成',
      resultEmpty: '请输入参数后点击“测算”，即可生成结果。',
      showDetails: '查看明细',
      hideDetails: '收起明细',
      summaryTableTitle: '折算与结算总表',
      detailTableTitle: '税费明细表',
      groupConversion: '折算类',
      groupSettlement: '结算类',
      colValue: '数值',
      colUnit: '单位',
      colFormula: '计算口径',
      yuan: '元',
      tceUnit: '吨标煤',
      formulaInput: '输入项',
      formulaRawCoalT: '毛煤量 × 折算系数',
      formulaStdCoalT: '折算后原煤量 × 低位发热量 ÷ 7000',
      formulaSalesExVat: '折算后原煤量 × 不含税单价',
      formulaVat: '不含税销售额 × 增值税率',
      formulaSalesIncVat: '不含税销售额 + 增值税',
      formulaOtherTaxFee: '资源税 + 附加税 + 安全/生态/基金等（不含增值税）',
      formulaTotalTaxFee: '其他税费合计 + 增值税',
      formulaNetSettle: '不含税销售额 - 其他税费合计(不含增值税)',
      resultMeaningTitle: '结果说明',
      meaningRawCoalT: '折算后原煤量：毛煤量 × 折算系数。',
      meaningStdCoalT: '折标煤量：折算后原煤量 × 低位发热量 ÷ 7000。',
      meaningSalesExVat: '不含税销售额：折算后原煤量 × 不含税单价。',
      meaningVat: '增值税(销项)：不含税销售额 × 增值税率。',
      meaningTotalTaxFee: '税费合计(含增值税)：其他税费合计 + 增值税(销项)。',
      meaningNetSettle: '结算净额(不含税)：不含税销售额 - 其他税费合计(不含增值税)。',
      grossCoalT: '毛煤量(吨)',
      convertCoeff: '毛煤→原煤折算系数',
      qnetKcalKg: '低位发热量(kcal/kg)',
      unitPriceExVat: '不含税单价(元/吨)',
      vatRate: '增值税率(%)',
      resourceTaxRate: '资源税率(%)',
      citySurtaxRate: '城建税率(%)',
      eduSurtaxRate: '教育费附加率(%)',
      localEduSurtaxRate: '地方教育附加率(%)',
      safetyFundPerTon: '安全生产费(元/吨)',
      envFundPerTon: '生态治理费(元/吨)',
      otherFundRate: '其他基金费率(%)',
      resultTitle: '测算结果',
      rawCoalT: '折算后原煤量(吨)',
      stdCoalT: '折标煤量(吨标煤)',
      salesExVat: '不含税销售额(元)',
      vatAmount: '增值税(销项)(元)',
      salesIncVat: '含税销售额(元)',
      totalOtherTaxFee: '其他税费合计(不含增值税)(元)',
      totalTaxFee: '税费合计(含增值税)(元)',
      netExVatAfterTaxFee: '结算净额(不含税)(元)',
      colName: '项目',
      colBase: '计提基础',
      colRate: '费率',
      colAmount: '金额(元)',
      colNote: '说明',
      resourceTax: '资源税',
      vat: '增值税',
      citySurtax: '城建税',
      eduSurtax: '教育费附加',
      localEduSurtax: '地方教育附加',
      safetyFund: '安全生产费',
      envFund: '生态治理费',
      otherFund: '其他基金',
      baseSalesExVat: '不含税销售额',
      baseVat: '增值税',
      baseRawCoal: '折算后原煤量',
      yuanPerTon: '元/吨',
      noteRateOnSales: '按不含税销售额计提',
      noteVatOutput: '按销项税额计算',
      noteSurtaxOnVat: '按增值税附加计提',
      notePerTonOnRaw: '按折算后原煤量计提',
      noteConfigurableExample: '可配置项',
      totalRow: '合计(含增值税)',
      totalRowNote: '含增值税的税费合计',
      subtotalRow: '小计(不含增值税)',
      subtotalRowNote: '除增值税外的税费合计',
      logicHint1: '折算逻辑：原煤量 = 毛煤量 × 折算系数；折标煤量 = 原煤量 × 低位发热量 ÷ 7000。',
      logicHint2: '税费逻辑为通用计算口径，参数可按企业/地区政策调整。'
    }
    ,
    washingReport: {
      breadcrumb: '洗选产品日报表',
      export: '导出',
      selectDate: '选择日期',
      search: '搜索',
      title: '晋城公司洗选产品数质量日报表',
      index: '序号',
      mineName: '煤矿名称',
      indicatorName: '指标名称',
      selectedCoal: '入选原煤',
      rawCoal: '入洗原煤',
      cleanCoal: '洗末精煤',
      lumpCoal: '洗块精煤',
      mediumCoal: '中煤',
      slurry: '煤泥',
      sieveCoal: '筛混煤',
      day: '当日',
      month: '月累',
      year: '年累',
      companyTotal: '公司合计',
      prodT: '产量（吨）',
      dateRequired: '日期不能为空!!!',
      fetchError: '网络异常！获取列表失败！'
    }
    ,
    recordSearch: {
      breadcrumb: '记录查询',
      rangeSeparator: '至',
      startDate: '开始日期',
      endDate: '结束日期',
      logType: '记录类型',
      all: '全部',
      login: '登录',
      visit: '访问',
      operate: '操作',
      exception: '异常',
      search: '搜索',
      index: '序号',
      operateTime: '操作时间',
      operator: '操作人',
      recordType: '记录类型',
      module: '模块',
      source: '来源',
      content: '内容',
      detail: '详情',
      dateRequired: '日期不能为空!!!',
      fetchError: '网络异常！获取列表失败！',
      shortcuts: {
        lastWeek: '最近一周',
        lastMonth: '最近一个月',
        lastThreeMonths: '最近三个月'
      }
    }
    ,
    combinedCurve: {
      breadcrumb: '流量速度曲线',
      selectScale: '请选择',
      datePh: '选择日期',
      startTimePh: '开始时间',
      endTimePh: '结束时间',
      search: '搜索',
      flowCurveTitle: '流量曲线',
      speedCurveTitle: '速度曲线',
      warn: {
        scaleRequired: '请选择秤',
        dateRequired: '请选择日期',
        startRequired: '请选择开始时间',
        endRequired: '请选择结束时间',
        timeRangeInvalid: '开始时间不能大于结束时间'
      },
      fetchFlowError: '网络异常！获取流量曲线失败！',
      fetchSpeedError: '网络异常！获取速度曲线失败！',
      fetchDeviceError: '网络异常！获取设备列表失败！',
      tooltip: {
        time: '时间',
        flow: '流量',
        speed: '速度'
      }
    }
    ,
    dischargeCurve: {
      breadcrumb: '流量曲线',
      selectScale: '请选择',
      datePh: '选择日期',
      startTimePh: '开始时间',
      endTimePh: '结束时间',
      search: '搜索',
      warn: {
        scaleRequired: '请选择秤',
        dateRequired: '请选择日期',
        startRequired: '请选择开始时间',
        endRequired: '请选择结束时间',
        timeRangeInvalid: '开始时间不能大于结束时间'
      },
      fetchError: '网络异常！获取列表失败！',
      tooltip: {
        time: '时间',
        flow: '流量'
      }
    }
    ,
    startStopRecord: {
      breadcrumb: '启停记录',
      rangeSeparator: '至',
      startDate: '开始日期',
      endDate: '结束日期',
      scale: '秤',
      search: '搜索',
      loading: '玩命加载中...',
      index: '序号',
      balanceId: '秤号',
      balanceName: '秤名',
      startTime: '开始运行时间',
      stopTime: '停止运行时间',
      startAccumulation: '开始时累积量',
      stopAccumulation: '停止时累积量',
      runningTime: '运行时间',
      oneTimeYield: '次产量',
      all: '全部',
      dateRequired: '日期不能为空!!!',
      fetchError: '网络异常！获取列表失败！'
    }
    ,
    offlineRecord: {
      breadcrumb: '离线记录',
      rangeSeparator: '至',
      startDate: '开始日期',
      endDate: '结束日期',
      scale: '秤',
      search: '搜索',
      loading: '玩命加载中...',
      index: '序号',
      balanceId: '秤号',
      balanceName: '秤名',
      connectionFailureTime: '连接失败时间',
      connectionRecoveryTime: '恢复连接时间',
      offlineDuration: '断开连接时长',
      all: '全部',
      dateRequired: '日期不能为空!!!',
      fetchError: '网络异常！获取列表失败！'
    }
    ,
    hisData: {
      breadcrumb: '历史数据',
      rangeSeparator: '至',
      startDate: '开始日期',
      endDate: '结束日期',
      scale: '秤',
      search: '搜索',
      loading: '玩命加载中...',
      index: '序号',
      operateTime: '操作时间',
      scaleId: '秤号',
      scaleName: '秤名',
      shift: '班次',
      speed: '速度(m/s)',
      flow: '流量(t/h)',
      weight: '重量(t)',
      totalWeightCol: '总重量(t)',
      loadingMore: '正在加载更多...',
      noMore: '没有更多数据了',
      dateRequired: '日期不能为空!!!',
      yes: '是',
      all: '全部',
      fetchError: '网络异常！获取列表失败！'
    }
    ,
    eventRecord: {
      breadcrumb: '监控记录',
      rangeSeparator: '至',
      startDate: '开始日期',
      endDate: '结束日期',
      eventType: '事件类型',
      search: '搜索',
      loading: '玩命加载中...',
      index: '序号',
      alarmTime: '报警时间',
      eventTypeCol: '报警事件',
      alarmInfo: '报警信息',
      operation: '操作',
      view: '查看',
      viewTitle: '查看详情',
      close: '关闭',
      all: '全部',
      dateRequired: '日期不能为空!!!',
      fetchError: '网络异常！获取列表失败！',
      shortcuts: {
        lastWeek: '最近一周',
        lastMonth: '最近一个月',
        lastThreeMonths: '最近三个月'
      }
    }
    ,
    
    personInfo: {
      tabsBase: '基本设置',
      tabsSecurity: '安全设置',
      baseTitle: '基本设置',
      securityTitle: '安全设置',
      loginId: '账号',
      deptName: '部门',
      realName: '姓名',
      remark: '个人简介',
      avatar: '头像',
      updateProfile: '更新个人信息',
      oldPassword: '旧密码',
      newPassword: '新密码',
      confirmPassword: '确认密码',
      updatePwd: '更新密码',
      rules: {
        nameRequired: '请输入姓名',
        oldRequired: '请输入旧密码',
        oldError: '旧密码错误!',
        newRequired: '请输入新密码',
        confirmRequired: '请输入确认密码',
        mismatch: '新密码和确认密码不一致!'
      },
      confirmUpdateProfile: '确定要修改个人信息吗？',
      confirmUpdatePwd: '确定要修改密码吗？',
      confirmTitle: '提示',
      addFail: '添加失败',
      updateFail: '更新失败!',
      networkAddError: '网络异常！添加失败'
    }
    ,
    tags: {
      options: '标签选项',
      closeOther: '关闭其他',
      closeAll: '关闭所有'
    }
    ,
    handover: {
      print: '打印',
      printTitle: '打印单据'
    }
    ,
    coalUploadRecord: {
      breadcrumb: '煤炭信息监管服务平台上传记录',
      rangeSeparator: '至',
      startDate: '开始日期',
      endDate: '结束日期',
      recordType: '记录类型',
      all: '全部',
      fail: '失败',
      success: '成功',
      search: '搜索',
      index: '序号',
      uploadTime: '上传时间',
      apiName: '接口名称',
      result: '上传结果',
      code: '返回值',
      msg: '返回内容',
      content: '上传内容',
      detail: '详情',
      dateRequired: '日期不能为空!!!',
      fetchError: '网络异常！获取列表失败！'
    }
    ,
    hourData: {
      breadcrumb: '时产量详情',
      print: '打印',
      export: '导出',
      totalWeight: '累计产量(t):',
      rangeSeparator: '至',
      startDate: '开始日期',
      endDate: '结束日期',
      scale: '秤',
      search: '搜索',
      index: '序号',
      date: '日期',
      scaleName: '秤名称',
      shift: '班次',
      hourWeight: '时产量(t)',
      cnb: '产能比(%)',
      invalidTime: '无效时间',
      shortcuts: {
        lastWeek: '最近一周',
        lastMonth: '最近一个月',
        lastThreeMonths: '最近三个月'
      },
      dateRequired: '日期不能为空!!!',
      yes: '是',
      fetchError: '网络异常！获取列表失败！',
      printTitle: '时产量详情',
      axisHour: '时间(时)'
    }
    ,
    dayData: {
      breadcrumb: '日产量详情',
      print: '打印',
      export: '导出',
      totalWeight: '累计产量(t):',
      rangeSeparator: '至',
      startDate: '开始日期',
      endDate: '结束日期',
      scale: '秤',
      search: '搜索',
      index: '序号',
      date: '日期',
      scaleId: '秤号',
      scaleName: '秤名称',
      dayWeight: '日产量(t)',
      dayCnb: '日产能比(%)',
      shortcuts: {
        lastWeek: '最近一周',
        lastMonth: '最近一个月',
        lastThreeMonths: '最近三个月'
      },
      dateRequired: '日期不能为空!!!',
      yes: '是',
      fetchError: '网络异常！获取列表失败！',
      printTitle: '日产量详情'
    }
    ,
    monthData: {
      breadcrumb: '月产量详情',
      print: '打印',
      export: '导出',
      totalWeight: '累计产量(t):',
      rangeSeparator: '至',
      startMonth: '开始月份',
      endMonth: '结束月份',
      scale: '秤',
      search: '搜索',
      index: '序号',
      date: '日期',
      scaleId: '秤号',
      scaleName: '秤名称',
      monthWeight: '月产量(t)',
      monthCnb: '月产能比(%)',
      shortcuts: {
        thisMonth: '本月',
        ytd: '今年至今',
        lastSixMonths: '最近六个月'
      },
      yes: '是',
      fetchError: '网络异常！获取列表失败！',
      printTitle: '月产量详情'
    }
    ,
    yearData: {
      breadcrumb: '年产量详情',
      print: '打印',
      export: '导出',
      totalWeight: '累计产量(t):',
      startYear: '开始年',
      endYear: '结束年',
      scale: '秤',
      search: '搜索',
      index: '序号',
      year: '年份',
      scaleId: '秤号',
      scaleName: '秤名称',
      yearWeight: '年产量(t)',
      yearCnb: '年产能比(%)',
      yes: '是',
      fetchError: '网络异常！获取列表失败！',
      printTitle: '年产量详情'
    }
    ,
    monthCCData: {
      breadcrumb: '月超产查询',
      print: '打印',
      export: '导出',
      annualCapacity: '年生产能力(kt)',
      monthlyCapacity: '月生产能力(t)',
      dayCapacity: '日生产能力(t)',
      monthlyOutput: '月产量(t)',
      monthlyCapacityRatio: '月产能比(%)',
      overproductionNum: '超产次数',
      monthPh: '选择年月',
      scale: '秤',
      search: '搜索',
      index: '序号',
      scaleName: '秤名称',
      dayWeight: '日产量(t)',
      dayCnb: '产能比(%)',
      overproductionStatus: '超产情况',
      normal: '正常',
      overproduction: '超产',
      severeOverproduction: '严重超产',
      exceed: '超出',
      overproductionDateDay: '时间(日)',
      yes: '是',
      all: '全部',
      fetchError: '网络异常！获取列表失败！',
      printTitle: '月超产详情'
    }
    ,
    yearCCData: {
      breadcrumb: '年超产查询',
      print: '打印',
      export: '导出',
      annualCapacity: '年生产能力(kt)',
      monthlyCapacity: '月生产能力(t)',
      annualOutput: '年产量(t)',
      annualCapacityRatio: '年产能比(%)',
      overproductionNum: '超产次数',
      yearPh: '选择年',
      scale: '秤',
      search: '搜索',
      index: '序号',
      scaleName: '秤名称',
      overWeight: '超产产量(t)',
      monthCnb: '产能比(%)',
      overproductionStatus: '超产情况',
      normal: '正常',
      overproduction: '超产',
      severeOverproduction: '严重超产',
      exceed: '超出',
      overproductionDateMonth: '时间(月)',
      yes: '是',
      all: '全部',
      fetchError: '网络异常！获取列表失败！',
      printTitle: '年超产详情'
    }
    ,
    mtStd: {
      search: '查询',
      print: '打印',
      export: '导出',
      all: '全部',
      index: '序号',
      mine: '煤矿',
      unit: '单位',
      unitT: 't',
      cnb: '产能比',
      annualCapacity: '年生产能力(kt)',
      monthCapacity: '月生产能力（产量计划）(t)',
      dayCapacity: '日生产能力（产量计划）(t)',
      hourCapacity: '时生产能力（产量计划）(t)',
      yearOutput: '年产量',
      monthOutput: '月产量',
      dayOutput: '日产量',
      output: '产量',
      overOutput: '超产产量',
      timeCol: '时间',
      monthUnit: '月',
      dayUnit: '日',
      hourUnit: '时',
      overMonths: '累计超产月数',
      overDays: '累计超产天数',
      nth: '第',
      nthAfter: '次',
      status: '状况',
      cumCount: '累计次数',
      cumTime: '累计时间',
      timeSpan: '起止时刻',
      remark: '备注',
      typePh: '异常类型',
      yearPh: '请选择年份',
      monthPh: '请选择月份',
      yearStartPh: '开始年份',
      yearEndPh: '结束年份',
      monthStartPh: '开始月份',
      monthEndPh: '结束月份',
      dateStartPh: '开始日期',
      dateEndPh: '结束日期',
      yearSuffix: '年',
      hours: '小时',
      minutes: '分钟',
      fetchError: '网络异常！获取数据失败！',
      rangeError: '开始时间不能大于结束时间',
      ongoing: '进行中',
      remarkEdit: '修改备注',
      remarkEditTip: '点击修改备注',
      confirm: '确定',
      cancel: '取消',
      severeOverOutput: '严重超产产量',
      severeOverMonths: '累计严重超产月数',
      severeOverDays: '累计严重超产天数'
    }
    ,
    mtRealtimeList: {
      breadcrumb: '实时列表显示',
      printTitle: '实时列表显示',
      dateCol: '日期',
      timeColT: '时间',
      lastSevere: '最后一次严重超产产量\\产能比\\时间',
      shiftOutput: '班产量',
      statusNormal: '正常',
      statusAbnormal: '异常',
      refresh: '刷新',
      regionPh: '省/市',
      companyPh: '集团/公司',
      shaftPh: '出煤井',
      shaftCol: '出煤井',
      severeOnly: '仅严重超产',
      abnormalOnly: '仅工作异常'
    }
    ,
    mtSevereOverYearShow: {
      breadcrumb: '严重超产按年显示',
      printTitle: '严重超产按年显示'
    }
    ,
    mtSevereOverMonthShow: {
      breadcrumb: '严重超产按月显示',
      printTitle: '严重超产按月显示'
    }
    ,
    mtOverYearShow: {
      breadcrumb: '超产按年显示',
      printTitle: '超产按年显示'
    }
    ,
    mtOverMonthShow: {
      breadcrumb: '超产按月显示',
      printTitle: '超产按月显示'
    }
    ,
    mtOutputYearQuery: {
      breadcrumb: '产量按年查询显示',
      printTitle: '产量按年查询显示'
    }
    ,
    mtOutputMonthQuery: {
      breadcrumb: '产量按月查询显示',
      printTitle: '产量按月查询显示'
    }
    ,
    mtOutputDayQuery: {
      breadcrumb: '产量按日查询显示',
      printTitle: '产量按日查询显示'
    }
    ,
    mtAbnormalDisplay: {
      breadcrumb: '系统工作异常显示',
      printTitle: '系统工作异常显示'
    }
    ,
    scaleGroup: {
      breadcrumb: '给料机组管理',
      add: '添加',
      delete: '删除',
      viewDict: '查看组字典',
      selectPh: '请选择',
      all: '全部',
      percent: '百分制',
      ratio: '比例制',
      search: '搜索',
      loading: '玩命加载中...',
      index: '序号',
      groupName: '组名',
      totalFlow: '总流量',
      percentType: '占比方式',
      enabled: '是否启用',
      modifyTime: '操作时间',
      operation: '操作',
      edit: '编辑',
      feederName: '给料机名称',
      materialName: '物料名称',
      ratioCol: '比例',
      setFlow: '设定流量',
      cancel: '取 消',
      confirm: '确 定',
      viewDictTitle: '查看秤字典',
      searchPh: '请输入分组名,设备名,物料名',
      deviceName: '设备名',
      close: '关 闭',
      addTitle: '新增秤组信息',
      editTitle: '修改秤组信息',
      tip: '提示',
      confirmDelete: '确定要删除吗？',
      confirmDeleteChild: '确定要删除吗？(子项也会删除哦)',
      deleteError: '网络异常！删除失败',
      fetchError: '网络异常！获取列表失败！',
      warn: {
        selectToDelete: '请选择删除的行！'
      }
    }
    ,
    balanceEmpower: {
      breadcrumb: '设备权限',
      add: '添加',
      delete: '删除',
      searchPh: '姓名或秤名',
      search: '搜索',
      loading: '玩命加载中...',
      index: '序号',
      user: '用户',
      device: '设备',
      detail: '详情',
      modifyTime: '操作时间',
      operation: '操作',
      edit: '编辑',
      selectPh: '请选择',
      deviceDisplay: '设备展示',
      cancel: '取 消',
      confirm: '确 定',
      addTitle: '新增设备权限',
      editTitle: '修改设备权限',
      tip: '提示',
      confirmDelete: '确定要删除吗？',
      deleteError: '网络异常！删除失败',
      fetchError: '网络异常！获取列表失败！',
      addError: '网络异常！添加失败',
      updateError: '网络异常！修改失败',
      valid: {
        userRequired: '请选择用户'
      },
      warn: {
        selectToDelete: '请选择删除的行！'
      }
    }
    ,
    monitorEqu: {
      breadcrumb: '监控设备管理',
      add: '添加',
      deployAll: '全部布防',
      undeployAll: '全部撤防',
      namePh: '名称',
      search: '搜索',
      loading: '玩命加载中...',
      index: '序号',
      scaleName: '秤名称',
      deviceName: '设备名称',
      deviceIP: '设备IP',
      devicePort: '设备端口',
      status: '状态',
      enabled: '是否启用',
      userName: '用户名',
      modifyTime: '操作时间',
      operation: '操作',
      edit: '编辑',
      delete: '删除',
      monitorTarget: '被监控设备',
      selectPh: '请选择',
      password: '密码',
      urlSuffix: '地址后缀',
      use: '是否使用',
      cancel: '取 消',
      confirm: '确 定',
      addTitle: '新增监控设备信息',
      editTitle: '修改监控设备信息',
      tip: '提示',
      confirmDelete: '确定要删除吗？',
      confirmDeploy: '确定要布防吗？',
      confirmUndeploy: '确定要撤防吗？',
      addSuccess: '添加成功',
      addError: '网络异常！添加失败',
      updateSuccess: '修改成功',
      updateFail: '修改失败',
      updateError: '网络异常！修改失败',
      deleteFail: '删除失败',
      deleteError: '网络异常！删除失败',
      deleteSuccess: '删除了{name}',
      deleteBatchSuccess: '删除了{names}',
      fetchError: '网络异常！获取列表失败！',
      valid: {
        deviceNameRequired: '请输入设备名称',
        deviceNameLength: '长度在 2 到 15 个字符',
        deviceIpRequired: '请输入设备IP',
        devicePortRequired: '请输入设备端口',
        userNameRequired: '请输入用户名',
        passwordRequired: '请输入密码',
        balanceRequired: '请选择设备'
      },
      warn: {
        selectToDelete: '请选择删除的行！'
      }
    }
    ,
    productPlan: {
      breadcrumb: '产量计划管理',
      add: '添加',
      delete: '删除',
      searchPh: '姓名或秤名',
      search: '搜索',
      loading: '玩命加载中...',
      index: '序号',
      name: '名称',
      yearProd: '年产量',
      monthProd: '月产量',
      dayProd: '日产量',
      hourProd: '时产量',
      enabled: '是否启用',
      modifyTime: '操作时间',
      operation: '操作',
      edit: '编辑',
      yearPlan: '年产量计划(kt)',
      monthPlan: '月产量计划(t)',
      dayPlan: '日产量计划(t)',
      hourPlan: '时产量计划(t)',
      cancel: '取 消',
      confirm: '确 定',
      addTitle: '新增产量计划',
      editTitle: '修改产量计划',
      tip: '提示',
      confirmDelete: '确定要删除吗？',
      deleteSuccess: '删除了【{names}】的产量计划',
      deleteFail: '删除失败',
      deleteError: '网络异常！删除失败',
      fetchError: '网络异常！获取列表失败！',
      addSuccess: '添加成功',
      addError: '网络异常！添加失败',
      updateSuccess: '修改成功',
      updateFail: '修改失败',
      updateError: '网络异常！修改失败',
      valid: {
        nameRequired: '请填写名称'
      },
      enabledTagOn: '启用',
      enabledTagOff: '停用',
      warn: {
        selectToDelete: '请选择删除的行！'
      }
    }
    ,
    dataMain: {
      breadcrumb: '数据字典',
      filterPh: '输入关键字进行过滤',
      add: '添加',
      delete: '删除',
      edit: '修改',
      dictType: '字典分类',
      searchPh: '请输入项目值或名称',
      searchNameCodePh: '请输入名称或编码',
      search: '搜索',
      index: '序号',
      itemName: '项目名',
      itemValue: '项目值',
      order: '排序',
      enabled: '有效',
      remark: '备注',
      close: '关 闭',
      cancel: '取 消',
      confirm: '确 定',
      parent: '上级',
      selectPh: '请选择',
      name: '名称',
      code: '编号',
      editItemTitle: '修改字典项信息',
      addItemTitle: '新增字典项信息',
      addTypeTitle: '新增分类',
      editTypeTitle: '修改分类',
      tip: '提示',
      confirmDelete: '确定要删除吗？',
      deleteSuccess: '删除了{names}',
      deleteFail: '删除失败',
      deleteError: '网络异常！删除失败',
      fetchError: '网络异常！获取列表失败！',
      addSuccess: '添加成功',
      addFail: '添加失败',
      addError: '网络异常！添加失败',
      updateSuccess: '修改成功',
      updateFail: '修改失败',
      updateError: '网络异常！修改失败',
      valid: {
        nameRequired: '请输入项目名',
        valueRequired: '请输入项目值'
      },
      warn: {
        selectLeftCategory: '请选择左侧分类!',
        selectLeafOnly: '不允许选择目录!',
        selectToDelete: '请选择删除的行！',
        selectOneToEdit: '请选择一项修改!',
        onlyOneToEdit: '只能选择一项修改!',
        hasChildren: '存在分类下有子项,请先删除子项!'
      }
    }
    ,
    equimentVersion: {
      breadcrumb: '协议版本信息',
      namePh: '名称',
      search: '搜索',
      loading: '玩命加载中...',
      index: '序号',
      name: '名称',
      version: '版本',
      organization: '公司',
      modifyTime: '操作时间',
      describe: '描述'
    }
    ,
    clearData: {
      breadcrumb: '数据清空',
      alert: '注:数据清空后无法恢复,请谨慎操作！',
      scale: '秤',
      selectPh: '请选择',
      type: '类型',
      radio: {
        pcOnly: '仅清空电脑数据',
        meterOnly: '仅清空仪表数据',
        both: '清空电脑及仪表数据'
      },
      submit: '清空数据',
      tip: '提示',
      warn: {
        selectScale: '请选择秤!'
      },
      confirmClear: '确定要清除数据吗？',
      opError: '网络异常，操作失败！',
      fetchError: '网络异常！获取列表失败！'
    }
    ,
    role: {
      breadcrumb: '角色管理',
      add: '添加',
      delete: '删除',
      codePh: '编码',
      namePh: '名称',
      search: '搜索',
      loading: '玩命加载中...',
      index: '序号',
      name: '角色名称',
      description: '角色描述',
      enabled: '是否启用',
      operateTime: '操作时间',
      actions: {
        edit: '编辑'
      },
      fields: {
        name: '名称',
        enabled: '是否启用',
        description: '角色描述'
      },
      dialog: {
        cancel: '取 消',
        confirm: '确 定',
        editTitleUpdate: '修改角色信息',
        editTitleAdd: '新增角色信息'
      },
      rules: {
        nameRequired: '请输入名称',
        lengthRange: '长度在 2 到 15 个字符'
      },
      notify: {
        addSuccess: '添加成功',
        addFail: '添加失败',
        networkAddError: '网络异常！添加失败',
        updateSuccess: '修改成功',
        updateFail: '修改失败',
        networkUpdateError: '网络异常！修改失败',
        networkListError: '网络异常！获取列表失败！',
        deleteSelectedWarning: '请选择删除的行！',
        deleteConfirm: '确定要删除吗？',
        deleteConfirmTitle: '提示',
        deleteSuccess: '删除了{names}',
        deleteFail: '删除失败',
        networkDeleteError: '网络异常！删除失败'
      },
      companyRoot: '公司根节点'
    }
    ,
    rolePermission: {
      breadcrumb: '角色权限',
      rolesTitle: '角色',
      permsTitle: '权限',
      refresh: '刷新',
      save: '保存',
      loading: '玩命加载中...',
      name: '名称',
      fetchError: '网络异常！获取列表失败！',
      warn: {
        selectRole: '请选择角色！',
        selectMenu: '请选择菜单！'
      }
    }
    ,
    frequency: {
      breadcrumb: '计划管理',
      add: '添加',
      delete: '删除',
      search: '搜索',
      namePh: '名称',
      loading: '玩命加载中...',
      index: '序号',
      planName: '计划名称',
      shift1Name: '班次一名称',
      shift1Start: '班次一开始时间',
      shift1End: '班次一结束时间',
      modifyTime: '操作时间',
      operation: '操作',
      edit: '编辑',
      shiftCount: '班次数量',
      customSettlementOn: '自定结算日期',
      customSettlementOff: '默认结算日期',
      eachMonth: '每月',
      shiftName: '班次名称',
      startTime: '开始时间',
      endTime: '结束时间',
      startTimePh: '开始时间',
      endTimePh: '结束时间',
      enabled: '启用',
      loopStart: '班次循环开始时间',
      loopEnd: '班次循环结束时间',
      cancel: '取 消',
      confirm: '确 定',
      addTitle: '新增计划信息',
      editTitle: '修改计划信息',
      viewTitle: '查看计划',
      close: '关闭',
      shiftName1: '班名称1',
      shiftName2: '班名称2',
      shiftName3: '班名称3',
      shiftName4: '班名称4',
      shiftName5: '班名称5',
      yes: '是',
      no: '否',
      day: {
        prev: '昨日',
        today: '今日',
        next: '明日'
      },
      valid: {
        nameRequired: '请输入名称',
        startTimeRequired: '请输入开始时间',
        endTimeRequired: '请输入结束时间'
      },
      warn: {
        selectToDelete: '请选择删除的行！',
        timeRequired: '{name}的开始结束时间都不为空!!!'
      },
      confirmDelete: '确定要删除吗？',
      tip: '提示',
      addSuccess: '添加成功',
      addFail: '添加失败',
      addError: '网络异常！添加失败',
      updateSuccess: '修改成功',
      updateFail: '修改失败',
      updateError: '网络异常！修改失败',
      fetchError: '网络异常！获取列表失败！',
      deleteError: '网络异常！删除失败',
      deleteSuccess: '删除了{names}'
    }
    ,
    balance: {
      breadcrumb: '设备管理',
      add: '添加',
      delete: '删除',
      paramCheck: '参数校验',
      search: '搜索',
      codePh: '编号',
      namePh: '名称',
      minePh: '煤矿',
      shaftPh: '出煤井',
      regionPh: '省市',
      companyPh: '集团/公司',
      loading: '玩命加载中...',
      index: '序号',
      region: '地区',
      mineName: '煤矿名称',
      scaleName: '秤名称',
      instrumentCode: '仪表编码',
      commType: '通讯类型',
      comPort: '串口/端口',
      rateIp: '波特率/IP',
      enabled: '是否启用',
      showMonitor: '是否显示监控',
      homePageDisplay: '首页展示',
      deviceType: '设备类型',
      agreementType: '协议类型',
      frequencyPlan: '班次计划',
      modifyTime: '操作时间',
      operation: '操作',
      edit: '编辑',
      warn: {
        regionRequired: '请选择地区!!!',
        selectToDelete: '请选择删除的行！',
        selectParamRow: '请选择设置参数的行！',
        onlyOneRow: '只能选择一行！',
        onlyEnabled: '只有启用的才能设置参数！'
      },
      confirmDelete: '确定要删除吗？',
      tip: '提示',
      addError: '网络异常！添加失败',
      updateError: '网络异常！修改失败',
      deleteError: '网络异常！删除失败',
      fetchError: '网络异常！获取列表失败！'
    }
    ,
    frequencyData: {
      breadcrumb: '班产量详情',
      print: '打印',
      export: '导出',
      totalWeight: '累计产量(t):',
      rangeSeparator: '至',
      startDate: '开始日期',
      endDate: '结束日期',
      scale: '秤',
      shift: '班次',
      all: '全部',
      search: '搜索',
      index: '序号',
      date: '日期',
      scaleId: '秤号',
      scaleName: '秤名称',
      shiftCol: '班次',
      freqWeight: '班产量(t)',
      shortcuts: {
        lastWeek: '最近一周',
        lastMonth: '最近一个月',
        lastThreeMonths: '最近三个月'
      },
      dateRequired: '日期不能为空!!!',
      yes: '是',
      fetchError: '网络异常！获取列表失败！',
      printTitle: '班产量详情'
    }
    ,
    hourlyPower: {
      breadcrumb: '时用电量详情',
      print: '打印',
      export: '导出',
      total: '累计电量(kw·h):',
      rangeSeparator: '至',
      startDate: '开始日期',
      endDate: '结束日期',
      type: '用电类型',
      search: '搜索',
      index: '序号',
      date: '日期',
      hour: '时间(时)',
      fifteenMin: '十五分钟用电量(kw·h)',
      hourPower: '时用电量(kw·h)',
      shortcuts: {
        lastWeek: '最近一周',
        lastMonth: '最近一个月',
        lastThreeMonths: '最近三个月'
      },
      all: '全部',
      type1: '煤矿总关口',
      type2: '井下供电关口',
      type3: '主运输设备供电关口',
      dateRequired: '日期不能为空!!!',
      fetchError: '网络异常！获取列表失败！',
      printTitle: '时用电量详情'
    }
    ,
    dailyPower: {
      breadcrumb: '日用电量详情',
      print: '打印',
      export: '导出',
      total: '累计电量(kw·h):',
      rangeSeparator: '至',
      startDate: '开始日期',
      endDate: '结束日期',
      type: '用电类型',
      search: '搜索',
      index: '序号',
      date: '日期',
      dayPower: '日用电量(kw·h)',
      shortcuts: {
        lastWeek: '最近一周',
        lastMonth: '最近一个月',
        lastThreeMonths: '最近三个月'
      },
      all: '全部',
      type1: '煤矿总关口',
      type2: '井下供电关口',
      type3: '主运输设备供电关口',
      dateRequired: '日期不能为空!!!',
      fetchError: '网络异常！获取列表失败！',
      printTitle: '日用电量详情'
    }
    ,
    motorMonitoringDevice: {
      breadcrumb: '电机监测设备',
      add: '添加',
      delete: '删除',
      search: '搜索',
      codePh: '编号',
      namePh: '名称',
      loading: '玩命加载中...',
      index: '序号',
      name: '名称',
      deviceCode: '设备编号',
      port: '端口',
      baudRate: '波特率',
      enabled: '是否启用',
      agreementType: '协议类型',
      modifyTime: '操作时间',
      operation: '操作',
      edit: '编辑',
      use: '是否使用',
      cancel: '取 消',
      confirm: '确 定',
      valid: {
        codeRequired: '请输入编号',
        codeLength: '长度在 1 到 15 个字符',
        nameRequired: '请输入名称',
        mineNameRequired: '请输入煤矿名称',
        planRequired: '请选择计划',
        zeroRequired: '请输入零点',
        kvRequired: '请输入校验值',
        speedCoeffRequired: '请输入速度系数'
      },
      warn: {
        selectToDelete: '请选择删除的行！',
        selectParamRow: '请选择设置参数的行！',
        onlyOneRow: '只能选择一行！',
        onlyEnabled: '只有启用的才能设置参数！'
      },
      confirmDelete: '确定要删除吗？',
      tip: '提示',
      addError: '网络异常！添加失败',
      updateError: '网络异常！修改失败',
      deleteError: '网络异常！删除失败',
      fetchError: '网络异常！获取列表失败！'
    }
    ,
    monthlyPower: {
      breadcrumb: '月用电量详情',
      print: '打印',
      export: '导出',
      total: '累计电量(kw·h):',
      rangeSeparator: '至',
      startMonth: '开始月份',
      endMonth: '结束月份',
      type: '用电类型',
      search: '搜索',
      index: '序号',
      date: '日期',
      monthPower: '月用电量(kw·h)',
      shortcuts: {
        thisMonth: '本月',
        ytd: '今年至今',
        lastSixMonths: '最近六个月'
      },
      all: '全部',
      type1: '煤矿总关口',
      type2: '井下供电关口',
      type3: '主运输设备供电关口',
      fetchError: '网络异常！获取列表失败！',
      printTitle: '月用电量详情'
    }
    ,
    annualPower: {
      breadcrumb: '年用电量详情',
      print: '打印',
      export: '导出',
      total: '累计电量(kw·h):',
      startYear: '开始年',
      endYear: '结束年',
      type: '用电类型',
      search: '搜索',
      index: '序号',
      year: '年份',
      yearPower: '年用电量(kw·h)',
      all: '全部',
      type1: '煤矿总关口',
      type2: '井下供电关口',
      type3: '主运输设备供电关口',
      fetchError: '网络异常！获取列表失败！',
      printTitle: '年用电量详情'
    }
    ,
    dailySales: {
      breadcrumb: '日累计销量',
      print: '打印',
      export: '导出',
      total: '累计销量(吨):',
      rangeSeparator: '至',
      startDate: '开始日期',
      endDate: '结束日期',
      search: '搜索',
      index: '序号',
      date: '日期',
      daySales: '日销量(吨)',
      dayCarCount: '日车次',
      shortcuts: {
        lastWeek: '最近一周',
        lastMonth: '最近一个月',
        lastThreeMonths: '最近三个月'
      },
      dateRequired: '日期不能为空!!!',
      fetchError: '网络异常！获取列表失败！',
      printTitle: '日累计销量详情'
    }
    ,
    monthlySales: {
      breadcrumb: '月累计销量',
      print: '打印',
      export: '导出',
      total: '累计销量(吨):',
      rangeSeparator: '至',
      startMonth: '开始月份',
      endMonth: '结束月份',
      search: '搜索',
      index: '序号',
      date: '日期',
      monthSales: '月销量(吨)',
      monthCarCount: '月车次',
      shortcuts: {
        thisMonth: '本月',
        ytd: '今年至今',
        lastSixMonths: '最近六个月'
      },
      fetchError: '网络异常！获取列表失败！',
      printTitle: '月累计销量详情'
    }
    ,
    annualSales: {
      breadcrumb: '年累计销量',
      print: '打印',
      export: '导出',
      total: '累计销量(吨):',
      startYear: '开始年',
      endYear: '结束年',
      search: '搜索',
      index: '序号',
      year: '年份',
      yearSales: '年销量(吨)',
      yearCarCount: '年车次',
      fetchError: '网络异常！获取列表失败！',
      printTitle: '年累计销量详情'
    }
    ,
    salesDetails: {
      breadcrumb: '磅单详情',
      rangeSeparator: '至',
      startDate: '开始日期',
      endDate: '结束日期',
      search: '搜索',
      loading: '玩命加载中...',
      index: '序号',
      operateTime: '操作时间',
      tare: '皮重(吨)',
      tonnagePound: '磅单吨数',
      buyerName: '购买方名称',
      carNum: '车牌号',
      driver: '司机',
      carrier: '承运单位',
      weighman: '司磅员',
      carNumColor: '车牌颜色',
      carType: '车型',
      crDirection: '行驶方向',
      all: '全部',
      dateRequired: '日期不能为空!!!',
      fetchError: '网络异常！获取列表失败！'
    }
    ,
    userManage: {
      breadcrumb: '用户管理',
      add: '添加',
      delete: '删除',
      phonePh: '手机号码',
      accountPh: '账号',
      search: '搜索',
      loading: '玩命加载中...',
      index: '序号',
      loginId: '账号',
      realName: '姓名',
      phone: '手机号',
      userType: '用户类型',
      dept: '部门',
      operator: '操作人',
      operateTime: '操作时间',
      actions: { edit: '编辑' },
      dialog: {
        editTitleUpdate: '修改用户信息',
        editTitleAdd: '新增用户信息',
        viewTitle: '查看用户',
        cancel: '取 消',
        confirm: '确 定',
        close: '关 闭'
      },
      fields: {
        account: '账号',
        name: '姓名',
        password: '密码',
        confirmPassword: '确认密码',
        phone: '联系电话',
        userRole: '用户角色',
        dept: '部门',
        remark: '备注'
      },
      rules: {
        usernameRequired: '请输入账号',
        lengthRange: '长度在 3 到 15 个字符',
        nameRequired: '请输入姓名',
        pwdSet: '请设置密码',
        pwdMin: '密码长度至少5位',
        confirmRequired: '请输入确认密码',
        mismatch: '两次密码不一致',
        roleTypeRequired: '请选择角色类型',
        phoneRequired: '请输入电话'
      },
      notify: {
        addSuccess: '添加成功',
        addFail: '添加失败',
        updateSuccess: '修改成功',
        updateFail: '修改失败',
        networkAddError: '网络异常！添加失败',
        networkUpdateError: '网络异常！修改失败',
        networkListError: '网络异常！获取列表失败！',
        deleteSelectedWarning: '请选择删除的行！',
        deleteConfirmTitle: '提示',
        deleteConfirm: '确定要删除吗？',
        deleteSuccess: '删除了{names}',
        deleteFail: '删除失败',
        networkDeleteError: '网络异常！删除失败'
      }
    }
    ,
    dept: {
      breadcrumb: '部门管理',
      add: '添加',
      delete: '删除',
      codePh: '编号',
      namePh: '名称',
      search: '搜索',
      loading: '玩命加载中...',
      index: '序号',
      code: '编号',
      name: '名称',
      phone: '电话',
      address: '地址',
      sort: '排序',
      enabled: '是否启用',
      operateTime: '操作时间',
      actions: { edit: '编辑' },
      dialog: {
        editTitleUpdate: '修改部门信息',
        editTitleAdd: '新增部门信息',
        cancel: '取 消',
        confirm: '确 定'
      },
      fields: {
        code: '编号',
        name: '名称',
        address: '地址',
        phone: '电话',
        leader: '领导',
        parent: '隶属于',
        sort: '排序',
        enabled: '是否使用',
        remark: '备注'
      },
      rules: {
        codeRequired: '请输入编号',
        lengthRange: '长度在 3 到 15 个字符',
        nameRequired: '请输入名称',
        ipRequired: '请输入ip'
      },
      warn: {
        levelNotAllowed: '该层级不能选择',
        parentChangeForbidden: '选中的部门隶属于修改前的部门，不允许修改！！！'
      },
      notify: {
        addSuccess: '添加成功',
        addFail: '添加失败',
        updateSuccess: '修改成功',
        updateFail: '修改失败',
        networkAddError: '网络异常！添加失败',
        networkUpdateError: '网络异常！修改失败',
        networkListError: '网络异常！获取列表失败！',
        deleteSelectedWarning: '请选择删除的行！',
        deleteConfirmTitle: '提示',
        deleteConfirm: '确定要删除吗？',
        deleteSuccess: '删除了{names}',
        deleteFail: '删除失败',
        networkDeleteError: '网络异常！删除失败'
      }
    }
    ,
    menu: {
      breadcrumb: '菜单管理',
      add: '添加',
      delete: '删除',
      namePh: '名称',
      codePh: '编号',
      search: '搜索',
      loading: '玩命加载中...',
      index: '序号',
      title: '名称',
      code: '编号',
      enabled: '是否启用',
      sort: '排序',
      actions: { edit: '编辑' },
      dialog: {
        editTitleUpdate: '修改菜单信息',
        editTitleAdd: '新增菜单信息',
        cancel: '取 消',
        confirm: '确 定'
      },
      fields: {
        parent: '隶属于',
        title: '名称',
        code: '编号',
        icon: '图标',
        sort: '排序',
        enabled: '是否使用',
        remark: '说明'
      },
      rules: {
        codeRequired: '请输入编号',
        lengthRange: '长度在 3 到 25 个字符',
        titleRequired: '请输入名称',
        sortRequired: '请输入排序'
      },
      notify: {
        addSuccess: '添加成功',
        addFail: '添加失败',
        updateSuccess: '修改成功',
        updateFail: '修改失败',
        networkAddError: '网络异常！添加失败',
        networkUpdateError: '网络异常！修改失败',
        networkListError: '网络异常！获取列表失败！',
        deleteSelectedWarning: '请选择删除的行！',
        deleteConfirmTitle: '提示',
        deleteConfirm: '确定要删除吗？',
        deleteSuccess: '删除了{names}',
        deleteFail: '删除失败',
        networkDeleteError: '网络异常！删除失败'
      },
      root: '根节点'
    }
    ,
    role: {
      breadcrumb: '角色管理',
      add: '添加',
      delete: '删除',
      codePh: '编号',
      namePh: '名称',
      search: '搜索',
      loading: '玩命加载中...',
      index: '序号',
      name: '名称',
      description: '描述',
      enabled: '是否启用',
      operateTime: '操作时间',
      actions: { edit: '编辑' },
      dialog: {
        editTitleUpdate: '修改角色信息',
        editTitleAdd: '新增角色信息',
        cancel: '取 消',
        confirm: '确 定'
      },
      fields: {
        name: '名称',
        enabled: '是否使用',
        description: '备注'
      },
      rules: {
        nameRequired: '请输入名称',
        lengthRange: '长度在 3 到 15 个字符'
      },
      notify: {
        addSuccess: '添加成功',
        addFail: '添加失败',
        updateSuccess: '修改成功',
        updateFail: '修改失败',
        networkAddError: '网络异常！添加失败',
        networkUpdateError: '网络异常！修改失败',
        networkListError: '网络异常！获取列表失败！',
        deleteSelectedWarning: '请选择删除的行！',
        deleteConfirmTitle: '提示',
        deleteConfirm: '确定要删除吗？',
        deleteSuccess: '删除了{names}',
        deleteFail: '删除失败',
        networkDeleteError: '网络异常！删除失败'
      },
      companyRoot: '公司'
    }
  }
  ,
  menus: {
    BasicInfo: '首页',
    ScaleIndex: '数据看板',
    DayData: '日产量',
    MonthData: '月产量',
    YearData: '年产量',
    HourData: '时产量',
    FrequencyData: '班产量',
    RecordSearch: '记录查询',
    EventRecord: '异常记录',
    OfflineRecord: '离线记录',
    DischargeCurve: '流量曲线',
    SpeedCurve: '速度曲线',
    CombinedCurve: '流量速度曲线',
    HisData: '历史数据',
    Frequency: '计划管理',
    Balance: '设备管理',
    ScaleGroup: '给料机组管理',
    BalanceEmpower: '设备权限',
    MonitorEqu: '监控设备',
    ProductPlan: '产量计划管理',
    MotorMonitoringDevice: '电机监测设备',
    DataMain: '数据字典',
    EquimentVersion: '协议版本信息',
    ClearData: '数据清空',
    Role: '角色管理',
    RolePermission: '角色权限',
    Menu: '功能模块设置',
    CoalTaxCalc: '折算与税费测算',
    AlarmControl: '报警控制',
    MTStandard: 'MT1082标准报表',
    MTRealtimeList: '实时列表显示',
    MTSevereOverYearShow: '严重超产按年显示',
    MTSevereOverMonthShow: '严重超产按月显示',
    MTOverYearShow: '超产按年显示',
    MTOverMonthShow: '超产按月显示',
    MTOutputYearQuery: '产量按年查询显示',
    MTOutputMonthQuery: '产量按月查询显示',
    MTOutputDayQuery: '产量按日查询显示',
    MTAbnormalDisplay: '系统工作异常显示'
  }
  ,
  menusTitles: {
    '设备动态信息': '设备动态信息',
    '皮带秤首页': '皮带秤首页',
    '动态信息': '动态信息',
    '皮带秤展示': '皮带秤展示',
    '皮带秤状态': '皮带秤状态',
    '运行状态': '运行状态',
    'AI称重系统': 'AI称重系统',
    'AI称重系统大屏': 'AI称重系统大屏',
    '秤架组管理': '秤架组管理',
    '托辊管理': '托辊管理',
    '托辊电机管理': '托辊电机管理',
    '托辊称重传感器管理': '托辊称重传感器管理',
    '托辊震动传感器管理': '托辊震动传感器管理',
    'AI称重系统监控设置': 'AI称重系统监控设置',
    'AI称重系统设置': 'AI称重系统设置',
    '系统设置': '系统设置',
    '用户管理': '用户管理',
    '部门管理': '部门管理',
    '菜单管理': '菜单管理',
    '关于': '关于',
    '设备设置': '设备设置',
    '设备管理': '设备管理',
    '监控设备': '监控设备',
    '电机监测设备': '电机监测设备',
    '设备权限': '设备权限',
    '产量计划管理': '产量计划管理',
    '给料机组管理': '给料机组管理',
    '计划管理': '计划管理',
    '超产查询': '超产查询',
    '年超产查询': '年超产查询',
    '月超产查询': '月超产查询',
    '产量查询': '产量查询',
    '班产量查询': '班产量查询',
    '时产量查询': '时产量查询',
    '日产量查询': '日产量查询',
    '月产量查询': '月产量查询',
    '年产量查询': '年产量查询',
    '数据查询': '数据查询',
    '流量曲线': '流量曲线',
    '监控记录': '监控记录',
    '启停记录': '启停记录',
    '历史数据': '历史数据',
    '数据清除': '数据清除',
    '数据字典': '数据字典',
    '功能模块设置': '功能模块设置',
    '协议版本信息': '协议版本信息',
    '角色管理': '角色管理',
    '角色权限': '角色权限',
    '报警消音控制': '报警消音控制'
  }
  ,
  common: {
    modifySuccess: '修改成功',
    modifyFail: '修改失败',
    networkListError: '网络异常！获取列表失败！',
    networkModifyError: '网络异常！修改失败',
    inputPositiveInt: '请输入正整数！',
    refresh: '刷新',
    reset: '重置',
    save: '保存'
  }
}
